/* ============================================================
   SONDER PE — Accesibilidad del drawer del header (Sonder 2.0, B1.2)

   Corrige dos carencias del drawer NATIVO de Horizon 4.1.1 (medidas en el
   Staging aprobado de B1.1, antes de B1.2). No sustituye ni reimplementa el
   componente: solo usa su API pública (`header-drawer.isOpen` / `.close()`).

   1. Volver con "atrás" (caché de página, bfcache): el navegador restaura la
      página tal como estaba, con el drawer ABIERTO y el scroll bloqueado
      (en escritorio táctil la página no se podía desplazar). Al restaurarse
      desde la caché se cierra el drawer.
   2. Foco: al cerrar el drawer (Escape, X, velo) con el foco dentro de él, el
      foco se perdía en <body>. Se devuelve al botón ☰ (WCAG 2.4.3).

   Sin dependencias, sin estilos y sin tocar el DOM. Si Horizon cambia su API,
   las dos mejoras se desactivan solas (no lanzan errores).
   ============================================================ */
(function () {
  'use strict';
  if (window.__sdrDrawerA11y) return;
  window.__sdrDrawerA11y = true;

  function drawer() {
    return document.querySelector('header-drawer');
  }

  // 1. Restauración desde bfcache.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var el = drawer();
    if (el && el.isOpen && typeof el.close === 'function') el.close();
  });

  // 2. Devolver el foco al ☰ al cerrar. Un único observador por elemento <header-drawer>
  //    (WeakSet): si el editor de Shopify vuelve a renderizar la sección
  //    (shopify:section:load) se engancha el elemento nuevo sin duplicar los existentes.
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  function watch() {
    var el = drawer();
    if (!el || typeof MutationObserver === 'undefined') return;
    if (observed) {
      if (observed.has(el)) return;
      observed.add(el);
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var details = m.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (details.classList.contains('menu-open')) return;
        if (!m.oldValue || m.oldValue.indexOf('menu-open') === -1) return; // no estaba abierto
        var summary = details.querySelector(':scope > summary');
        var active = document.activeElement;
        if (!summary || active === summary) return;
        if (active === document.body || details.contains(active)) summary.focus({ preventScroll: true });
      });
    }).observe(el, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', watch);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
